module.exports = __webpack_public_path__ + "img/owl-purple-right.458aa2e9.png";